import React, { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";

const Navbar = lazy(() => import("../components/Navbar/Navbar"));
const Footer = lazy(() => import("../components/Footer/Footer"));

function Loader() {
  return <div style={{ padding: 12 }}>Loading...</div>;
}

export default function RootLayout() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <header style={{ borderBottom: "1px solid #eee" }}>
        <Suspense fallback={<Loader />}>
          <Navbar />
        </Suspense>
      </header>

      {/* Main content */}
      <main style={{ padding: 16, flex: 1 }}>
        <Outlet />
      </main>

      {/* Footer */}
      <footer style={{ padding: 16, borderTop: "1px solid #eee" }}>
       <Footer/>
      </footer>
    </div>
  );
}
